var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/_html.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/_html.js
// module chunks = 4